import React, { useEffect, useRef } from 'react';
import { faClose, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import useReliableCatalogCarQueryParams from 'utils/hooks/useReliableCatalogCarQueryParams';
import './CatalogOilFilter.scss';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import { isRetailerMecadepotChild } from 'utils/isRetailerMecadepotChild';

type Props = {
  setOpenFilter?: (boolean) => void;
  openFilter?: boolean;
  filterData?;
  getData?;
  setPage?: (number) => void;
};

const CatalogOilFilter: React.FC<Props> = (props) => {
  const { control, getValues, reset, setValue } = useForm();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const reliableSearchParams = useReliableCatalogCarQueryParams();
  const { isMobile, isTablet } = useDeviceDetect();


  const getOptions = (key) => {

    if (props.filterData && (key in props.filterData)) {
      return (
        props.filterData[key]?.map((item) => ({
          label: item.key,
          value: item.value,
        })) || []
      );
    }
  };


  function handleClick() {
    const params = {
      brand_id: Array.isArray(getValues()?.brand) ? getValues()?.brand?.map(({ value }) => value) : (getValues()?.brand?.value && [getValues()?.brand?.value]),
      quantity: Array.isArray(getValues()?.quantity) ? getValues()?.quantity?.map(({ value }) => value) : (getValues()?.quantity?.value && [getValues()?.quantity?.value]),
      family: Array.isArray(getValues()?.family) ? getValues()?.family?.map(({ value }) => value) : (getValues()?.family?.value && [getValues()?.family?.value]),
      viscosity: Array.isArray(getValues()?.viscosity) ? getValues()?.viscosity?.map(({ value }) => value) : (getValues()?.viscosity?.value && [getValues()?.viscosity?.value]),
      q: searchParams.get('q'),
      search: searchParams.get('search'),
      sort: String(searchParams.get('sort') || 'available'),
      asc: String(searchParams.get('asc') || 'false')
    };

    if (!isRetailerMecadepotChild() && props.setPage) {
      props.setPage(1);
    }


    const validParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (!value || !value.length) {
        return acc;
      }

      acc[key] = value;

      return acc;
    }, {} as { [key: string]: string | string[] });


    setSearchParams({ ...validParams, ...reliableSearchParams });
    props.setOpenFilter!(false);
  }

  function handleReset() {
    reset({ brand: '', quantity: '', family: '', viscosity: '' });
    const params = {
      q: searchParams.get('q'),
      search: searchParams.get('search'),
      sort: String(searchParams.get('sort') || 'available'),
      asc: String(searchParams.get('asc') || 'false')
    };

    if (!isRetailerMecadepotChild() && props.setPage) {
      props.setPage(1);
    }

    const validParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (!value || !value.length) {
        return acc;
      }

      acc[key] = value;

      return acc;
    }, {} as { [key: string]: string | string[] });

    setSearchParams({ ...reliableSearchParams, ...validParams });
    props.setOpenFilter!(false);
  }

  useEffect(() => {
    const foundBrands = props.filterData && props.filterData?.brand?.filter(item => {
      return searchParams.getAll('brand_id').includes(String(item.value));
    });

    if (foundBrands?.length) {
      setValue('brand', foundBrands.map(item => {
        return { label: item.key, value: item.value };
      }));
    }

    const foundFamily = props.filterData && props.filterData?.family?.filter(item => {
      return searchParams.getAll('family').includes(String(item.value));
    });

    if (foundFamily?.length) {
      setValue('family', foundFamily.map(item => {
        return { label: item.key, value: item.value };
      }));
    }

    const foundQuantity = props.filterData && props.filterData?.quantity?.filter(item => {
      return searchParams.getAll('quantity').includes(String(item.value));
    });

    if (foundQuantity?.length) {
      setValue('quantity', foundQuantity.map(item => {
        return { label: item.key, value: item.value };
      }));
    }

    const foundViscosity = props.filterData && props.filterData?.viscosity?.filter(item => {
      return searchParams.getAll('viscosity').includes(String(item.value));
    });

    if (foundViscosity?.length) {
      setValue('viscosity', foundViscosity.map(item => {
        return { label: item.key, value: item.value };
      }));
    }
  }, [props.filterData]);

  return (
    <div ref={filterRef} className={`oils-filters-catalog  ${props.openFilter ? 'active' : ''}`}>
      <div className="header">
        <div className="buttons-container">
          <LinkButton title={t('_reset')} icon={faRedo} onClick={handleReset} />
        </div>
        <div onClick={() => props.setOpenFilter!(false)}>
          <FontAwesomeIcon className="icon" icon={faClose} />
        </div>
      </div>
      <div className="title">
        <Trans i18nKey="_filter_results" components={{ b: <strong /> }} />
      </div>
      <div className="filters">
        <div className="dropdowns-container">
          {/* <div className="dropdown-item">
            <label className="dropdown-label">{t('_oil_category')}</label>
            <Controller
              control={control}
              name="category"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  isDisabled={value?.is_amerigo}
                  options={getOptions('category')}
                  placeholder={t('_oil_category')}
                  isClearable={false}
                  menuPlacement="auto"
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div> */}
          <div className="dropdown-item">
            <label className="dropdown-label">{t('_oil_brand')}</label>
            <Controller
              control={control}
              name="brand"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  isMulti
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  options={getOptions('brand')}
                  placeholder={t('_oil_brand')}
                  menuPlacement="top"
                  isClearable={false}
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div>
          <div className="dropdown-item">
            <label className="dropdown-label">{t('_oil_family')}</label>
            <Controller
              control={control}
              name="family"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  isMulti
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  options={getOptions('family')}
                  placeholder={t('_oil_family')}
                  isClearable={false}
                  menuPlacement="top"
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div>
          <div className="dropdown-item">
            <label className="dropdown-label">{t('_oil_quantity')}</label>
            <Controller
              control={control}
              name="quantity"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  isMulti
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  options={getOptions('quantity')}
                  placeholder={t('_oil_quantity')}
                  isClearable={false}
                  menuPlacement="top"
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div>
          <div className="dropdown-item">
            <label className="dropdown-label">{t('_oil_viscosity')}</label>
            <Controller
              control={control}
              name="viscosity"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  isMulti
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  options={getOptions('viscosity')}
                  placeholder={t('_oil_viscosity')}
                  isClearable={false}
                  menuPlacement="top"
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div>
        </div>
      </div>
      <div className="apply-btn">
        <DefaultButton text={t('_apply')} onClick={() => handleClick()} />
      </div>
    </div>
  );
};

export default CatalogOilFilter;
